import { SCHEDULING_FIELD_OPTIONS } from '../../constants';

// =============================================================================
// OPTIONS REF MAP (for grouped_multiselect)
// =============================================================================
export const OPTIONS_REF_MAP = {
  SCHEDULING_FIELD_OPTIONS: SCHEDULING_FIELD_OPTIONS,
};

// =============================================================================
// REACT-SELECT CUSTOM STYLES
// =============================================================================
export const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? 'var(--primary)' : 'var(--border-color)',
    boxShadow: state.isFocused ? '0 0 0 1px var(--primary)' : 'none',
    '&:hover': {
      borderColor: 'var(--primary-light)',
    },
    fontSize: '14px',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'var(--primary)'
      : state.isFocused
      ? 'var(--primary-50)'
      : 'transparent',
    color: state.isSelected ? 'white' : 'var(--text-primary)',
    cursor: 'pointer',
    fontSize: '13px',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'var(--primary-100)',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--primary)',
    fontSize: '12px',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--primary)',
    '&:hover': {
      backgroundColor: 'var(--primary)',
      color: 'white',
    },
  }),
  groupHeading: (base) => ({
    ...base,
    fontWeight: 700,
    fontSize: '12px',
    color: 'var(--text-secondary)',
    textTransform: 'none',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--text-muted)',
    fontSize: '13px',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
